<template>
  <div
    class="align-items-center d-flex stepper-element"
    v-bind:class="{ active: isActive, pointer: !disabled }"
    @click="goToDestination"
  >
    {{ text }}
  </div>
</template>

<script>
import router from "../router";
export default {
  name: "Stepper",
  props: {
    text: String,
    destination: String,
    isActive: Boolean,
    disabled: Boolean
  },
  methods: {
    goToDestination() {
      if (!this.disabled) {
        // console.log("goto ", this.destination);
        router.push(this.destination);
      }
    }
  }
};
</script>

<style scoped></style>
